module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-71.9e2f36b.woff2";